import { Text, View } from 'react-native'

/**
 * Vacation state chip. On: raised chip with a palm. Off: the same shape,
 * muted (transparent fill, softer border and text, no palm), so the two
 * states read as one control in different positions rather than a chip vs
 * loose text.
 */
export function VacationStatusChip({ active = true }: { active?: boolean }) {
  if (!active) {
    return <View accessibilityLabel="Vacation mode is off" testID="vacation-status-off"
      className="border border-olive/50 rounded-lg px-2 py-1 flex-row items-center" style={{ flexShrink: 0, minHeight: 30 }}>
      <Text className="font-stencil text-ink-soft text-xs">Off</Text>
    </View>
  }
  return <View accessibilityLabel="Vacation mode is on" className="bg-paper-up border border-olive rounded-lg px-2 py-1 flex-row items-center gap-2" style={{ flexShrink: 0 }}>
    <Text className="font-stencil text-ink text-xs">On</Text>
    <Text className="text-base">🌴</Text>
  </View>
}
